import templateUrl from "emun.order/change-notices/change-notice-list-grid.htm";

export default () => ({ templateUrl });